import gql from "graphql-tag";

export const UPDATE_ORDER = gql`
 mutation ($id: uuid!, $status: String!) {
 update_Orders (where: {id: {_eq: $id}}
    _set: {status: $status}) {
    returning {
      id
     }
    } 
  }
`